// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__P4ERl","loading":"styles_loading__2WQav"};